import { CommonModule } from "@angular/common";
import { Component, OnDestroy, OnInit } from "@angular/core";

import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { Subject, takeUntil } from "rxjs";
import { ActionButtonComponent } from "../../shared/components/action-button/action-button.component";
import { PlusmoreLogoComponent } from "../../shared/components/plusmore-logo/plusmore-logo.component";
import { registrationActions } from "../registration/store/actions";
import { AuthState } from "./auth.model";
import { authActions } from "./store/actions";
import { selectAuthState } from "./store/selectors";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-login",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    ActionButtonComponent,
    PlusmoreLogoComponent,
  ],
  templateUrl: "./login.component.html",
  styleUrl: "./login.component.scss",
})
export class LoginComponent implements OnInit, OnDestroy {
  constructor(
    private _formBuilder: FormBuilder,
    private router: Router,
    private store: Store<{ auth: AuthState }>
  ) {}

  logo: string = "logo/plusmore_logo.svg";
  loginFormGroup!: FormGroup;
  destroy$: Subject<void> = new Subject();

  ngOnInit(): void {
    this.setupAuthStateListener();
    this.setupLoginForm();
  }

  setupAuthStateListener() {
    this.store
      .select(selectAuthState)
      .pipe(takeUntil(this.destroy$), takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (res.success) {
            this.store.dispatch(
              registrationActions.canvasserLogin({ username: res.username! })
            );

            this.router.navigate(["/registration"]);
          }
        },
      });
  }

  setupLoginForm(): void {
    this.loginFormGroup = this._formBuilder.group({
      username: ["", Validators.required],
    });
  }

  login(): void {
    this.store.dispatch(
      authActions.requestLogin({
        username: this.loginFormGroup.get("username")?.getRawValue(),
      })
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  protected readonly environment = environment;
}
